import { Navigate, Route, Routes } from "react-router-dom";
import LandingComponent from './componants/landing';
import HomeCompontant from './componants/home';
import SkillComponant from "./componants/skills";
import AboutComponent from "./componants/about";
import ContactComponent from "./componants/contact";
import './index.css';


function App() {
  return (
    <Routes>
      <Route path="/contact" element={<ContactComponent />} />
      <Route path="/about" element={<AboutComponent />} />
      <Route path="/skills" element={<SkillComponant />} />
      <Route path="/home" element={<HomeCompontant />} />
      <Route path="/" element={<LandingComponent />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
